import { useNavigate } from "react-router-dom";
import { Banner, BlueLarge, IndIcon, USAIcon } from "../images/index";
import ScrollToTopButton from "../components/ScrollToTopButton";
import {
  Image337,
  EmpImg,
  image360,
  image361,
  image362,
  Content363,
  image364,
  image365,
  freepik,
  Vector2122,
  EqualEmployment,
  EmpHandbook,
  Dependent,
  Dental,
  ContactHR,
  Commuter,
  image366,
  downloadIcon,
  Group1000006130,
  Group1000006131,
  Group1000006132,
  image369,
  i1,
  i2,
  i3,
  PIcon,
  image368,
  EmpImg2,
  Frame117,
  image385,
  checkMark,
  image389,
  image387,
  image388,
} from "../images/Employee";
import { link } from "framer-motion/client";
import { useState, useEffect } from "react";
import { Image309 } from "../images/Industries";
import policies_image from "../images/policies_image.png";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug } from "../services/apiService";

const tabsData = [
  {
    id: "indianEmployees",
    label: "Indian Employees",
    icon: IndIcon,
  },
  {
    id: "usaEmployees",
    label: "USA Employees",
    icon: USAIcon,
  },
];

const tabWiseData = [
  {
    id: "indianEmployees",
    empBenefitsData: [
      {
        h1: "Employee Benefits & Policies",
        img: EmpImg2,
        p: "We offer comprehensive benefits designed to support employee health, financial security, work-life balance, and overall well-being. Below is a clear breakdown of all benefits provided to our full-time team members.",
      },
    ],
    insuranceHead: [
      {
        h1: "Insurance Policy",
        subHead:
          "Comprehensive medical coverage for employees and their families.",
        p: "Our insurance policy is designed to support your health and financial security. Below are the key terms and conditions that define your medical coverage at TechProjects. Medical Policy — Terms & Conditions Coverage Details",
      },
    ],
    EmpBenefits: [
      {
        image: image362,
        title: "Age Band",
        p: "Covers newborns to senior dependents.",
      },
      {
        image: image360,
        title: "Family Definition",
        p: "Employee, Spouse, 4 dependent children (up to 25 yrs), and Employee Parents Extensive family protection included.",
      },
      {
        image: image361,
        title: "Sum Insured (SI)",
        p: "₹10,00,000 per family (total) per policy year One consolidated coverage amount for the entire family.",
      },
    ],
    otherEmpBenefits: [
      {
        image: Group1000006130,
        title: "Shift Hours",
        p: "2:30 PM – 11:30 PM (with a 60-minute break) As part of our hybrid model, employees are eligible to work three days a week from the office.",
      },
      {
        image: Group1000006131,
        title: "Cab Allowance",
        p: "We provide cab allowance to support safe and easy travel for employees working approved shifts.",
      },
      ,
      {
        image: policies_image,
        title: "Policies",
        p: "View all company policies and guidelines designed to support employees and maintain a safe, fair workplace.",
      },
    ],
  },

  {
    id: "usaEmployees",
    empBenefitsData: [
      {
        h1: "Employee Benefits That Support You",
        img: EmpImg,
        p: "At TechProjects, we combine great earning potential with corporate-grade benefits. From healthcare to bonuses, we ensure every employee is rewarded for their contribution.",
      },
    ],
    EmpBenefits: [
      {
        image: image362,
        title: "Health, Dental & Vision Coverage",
        p: "Comprehensive plans for you and your family.",
      },
      {
        image: image360,
        title: "401(k) Retirement Plan",
        p: "Secure your future with retirement benefits.",
      },
      {
        image: image361,
        title: "Commuter Benefits",
        p: "Save on daily travel with pre-tax commuter programs.",
      },
      {
        image: Content363,
        title: "Paid Time Off & Holidays",
        p: "Enjoy flexible time for personal and family needs.",
      },
      {
        image: image364,
        title: "Dependent Care Program",
        p: "Flexible spending accounts for family support.",
      },
      {
        image: image365,
        title: "Bonus & Review Policy",
        p: "Transparent reviews and performance-linked bonuses.",
      },
    ],
  },
];

const EmpResourceData = [
  {
    icon: EmpHandbook,
    title: "Employee Handbook",
    link: "https://techprojects-website.s3.ap-south-1.amazonaws.com/PDF's/EmployeeHandBook/Employee_Handbook+-++Dice+IT+Solutions+LLC+DBA+TechProjects.pdf",
  },
  {
    icon: Dental,
    title: "Medical & Dental Benefits",
    link: "https://techprojects-website.s3.ap-south-1.amazonaws.com/PDF's/EmployeeHandBook/Medical-and-Dental-Vision-Benefits-TechProjects+-+2025+To+2026.pdf",
  },
  {
    icon: Dependent,
    title: "Dependent Care Benefits",
    link: "https://techprojects-website.s3.ap-south-1.amazonaws.com/PDF's/EmployeeHandBook/Dependent-Care-Benefits.pdf",
  },
  {
    icon: Commuter,
    title: "Commuter Benefits",
    link: "https://techprojects-website.s3.ap-south-1.amazonaws.com/PDF's/EmployeeHandBook/Commuter-Benefits.pdf",
  },
  {
    icon: EqualEmployment,
    title: "Equal Employment Opportunities",
    link: "https://techprojects-website.s3.ap-south-1.amazonaws.com/PDF's/EmployeeHandBook/Equal+Employment+Opportunity+and+Affirmative+Action+Policy+Form+-++Dice+IT+Solutions+LLC.pdf",
  },
  {
    icon: ContactHR,
    title: "Contact HR Team",
    link: "/contact",
  },
];

const workingTechproject = [
  {
    image: Group1000006130,
    title: "Competitive Pay & Bonuses",
    p: "We offer industry-leading salaries, annual bonuses, and performance rewards that recognize your impact.",
  },
  {
    image: Group1000006131,
    title: "Work–Life Balance",
    p: " Flexible work hours, generous leave policies, and wellness programs to support your well-being.",
  },
  {
    image: Group1000006132,
    title: "Global Team Support",
    p: "24/7 collaboration between our U.S. and India teams ensures learning, teamwork, and innovation around the clock.",
  },
];

const rewardsData = [
  {
    icon: i1,
    title: "Submit your referral form",
  },
  {
    icon: i2,
    title: "Candidate joins and completes 90 days",
  },
  {
    icon: i3,
    title: "You receive your reward!",
  },
];

const roles = [
  {
    icon: PIcon,
    role: "Systems Analyst",
    work: "North Brunswick, NJ :",
    workPlace: "Hybrid",
    d2: "ERP, Supply Chain, Oracle :",
    workExp: "3+ yrs exp",
    ref: "Accepting referrals until :",
    date: "October 28, 2026",
  },
  {
    icon: PIcon,
    role: "HR Specialist",
    work: "North Brunswick, NJ :",
    workPlace: "Onsite",
    d2: "Recruiting, Employee Relations, Payroll :",
    workExp: "3+ yrs exp",
    ref: "Accepting referrals until :",
    date: "October 28, 2026",
  },
  {
    icon: PIcon,
    role: "Software Engineer",
    work: "North Brunswick, NJ :",
    workPlace: "Remote",
    d2: "NET, Web APIs, Cloud CI/CD :",
    workExp: "5+ yrs exp",
    ref: "Accepting referrals until :",
    date: "October 28, 2026",
  },
];

function Employee() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("indianEmployees");
  const currentTabData = tabWiseData?.find((item) => item?.id === tab);
  const handleClick = () => {
    navigate("/contact");
  };
  const [metaData, setMetaData] = useState({});
  const slug = useSlug();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const slugData = await getPagesBySlug(slug.toLowerCase());
        setMetaData(slugData.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
  }, []);

  const handleAction = (item) => {
    if (item?.title !== "Contact HR Team") {
      const link = document.createElement("a");
      link.href = item.link;
      link.target = "_blank";
      link.download = item.title || "file";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      navigate(item?.link);
    }
  };

  const handlePoliciesDownload = () => {
    const link = document.createElement("a");
    link.href = "/docs/Employee_Benefits.docx";
    link.download = "Employee_Benefits.docx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[630px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 h-full w-full "
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 left-0 right-0">
            <div className="max-w-3xl font-roboto space-y-6">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569] font-bold text-xl">
                  WHERE TECHNOLOGY MEETS INDUSTRY
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Empower Your Career at TechProjects
              </h1>
              <p className="text-md text-[#404040]">
                Discover employee benefits, policies, and programs designed to
                help you thrive personally and professionally.
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-[6rem]">
              <img src={Image337} alt="IT Hiring" className="w-full h-auto" />
            </div>
          </div>
        </div>

        <div className="flex justify-center w-full gap-3 mt-10 mb-10 font-roboto">
          {tabsData?.map((item) => (
            <button
              key={item?.id}
              onClick={() => setTab(item?.id)}
              className={`flex justify-center items-center font-500 gap-2 px-4 py-2 rounded-md font-medium text-lg focus:outline-none transition-all ${
                tab === item?.id
                  ? "bg-activeColor text-white shadow"
                  : "bg-white text-[#0F172A]"
              }`}
            >
              <img src={item?.icon} alt={item?.label} />
              {item?.label}
            </button>
          ))}
        </div>

        {currentTabData && (
          <>
            <section className="bg-white px-6 md:px-0 relative overflow-hidden font-roboto bg-[#F7F7F7]">
              <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
                <div className="relative flex justify-center md:justify-start">
                  <img
                    src={currentTabData?.empBenefitsData[0]?.img}
                    alt={currentTabData?.empBenefitsData[0]?.h1}
                    className="object-cover"
                  />
                </div>
                <div>
                  <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                    <span className="w-[21px] h-[6px] bg-activeColor"></span>
                    <span className="w-[36px] h-[6px] bg-activeColor"></span>
                  </span>
                  <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] leading-tight mb-4">
                    {currentTabData?.empBenefitsData[0]?.h1}
                  </h2>
                  <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                    {currentTabData?.empBenefitsData[0]?.p}
                  </p>
                </div>
              </div>
            </section>

            <section className="bg-white font-roboto px-6 py-6 md:px-0">
              <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center">
                {currentTabData?.insuranceHead && (
                  <>
                    <div className="w-[59rem] mx-auto">
                      <span className="flex justify-center items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                        <span className="w-[21px] h-[6px] bg-activeColor"></span>
                        <span className="w-[36px] h-[6px] bg-activeColor"></span>
                      </span>
                      <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] leading-tight mb-4">
                        {currentTabData?.insuranceHead[0]?.h1}
                      </h2>
                      <p className="text-3xl font-500 text-[#434253] mb-6 leading-relaxed">
                        {currentTabData?.insuranceHead[0]?.subHead}
                      </p>
                      <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                        {currentTabData?.insuranceHead[0]?.p}
                      </p>
                    </div>
                  </>
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 mt-16">
                  {currentTabData?.EmpBenefits?.map((i, index) => (
                    <div
                      key={index}
                      className="flex flex-col items-center sm:items-center lg:items-center text-center sm:text-center lg:text-center bg-[#F0F6FF] rounded-[1rem] p-6"
                    >
                      <div className="mb-4">
                        <img src={i?.image} alt={i?.title} />
                      </div>
                      <h3 className="text-xl font-bold text-[#0F172A] mb-2">
                        {i?.title}
                      </h3>
                      <p className="text-[#0F172A] text-lg font-400 leading-relaxed">
                        {i?.p}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </>
        )}

        {tab === "indianEmployees" && (
          <>
            <section className="font-roboto px-6 py-6 md:px-0">
              <div
                className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] py-10 px-6 md:py-[80px] md:px-[120px] mx-auto rounded-[30px] md:rounded-[50px] text-white bg-cover bg-center"
                style={{ backgroundImage: `url(${BlueLarge})` }}
              >
                <div className="grid space-y-4 md:space-y-6">
                  <h2 className="font-extrabold text-3xl sm:text-4xl md:text-5xl leading-tight">
                    Life Insurance & ADD Coverage
                  </h2>

                  <p className="font-medium text-xl sm:text-2xl md:text-3xl">
                    Effective January 1, 2026
                  </p>
                </div>

                <div className="flex flex-col md:flex-row gap-8 md:gap-5 mt-10">
                  <div className="md:w-1/2">
                    <p className="font-normal text-lg sm:text-xl md:text-2xl mt-5">
                      Your benefits will expand with life insurance and
                      accidental disability coverage, ensuring:
                    </p>

                    <ul className="font-normal text-base sm:text-lg md:text-xl mt-6 md:mt-16 space-y-5 ml-5">
                      <li className="flex gap-3">
                        <img src={checkMark} alt="check-mark" />
                        Stronger financial support
                      </li>
                      <li className="flex gap-3">
                        <img src={checkMark} alt="check-mark" />
                        Protection during unexpected events
                      </li>
                      <li className="flex gap-3">
                        <img src={checkMark} alt="check-mark" /> Added peace of
                        mind for your family
                      </li>
                    </ul>
                  </div>

                  <div className="md:w-1/2 flex justify-center md:justify-end">
                    <img
                      src={image385}
                      className="w-full max-w-xs sm:max-w-sm md:max-w-md object-contain"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </section>

            <section className="bg-white font-roboto px-6 py-6 md:px-0">
              <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto">
                <>
                  <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                    <span className="w-[21px] h-[6px] bg-activeColor"></span>
                    <span className="w-[36px] h-[6px] bg-activeColor"></span>
                  </span>
                  <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] leading-tight mb-4">
                    Other Employee Benefits
                  </h2>
                  <p className="text-3xl font-400 text-[#434253] mb-6 leading-relaxed">
                    We support our employees with flexible work schedules, clear
                    shift timings, and safe commute options to ensure a smooth
                    and secure work experience.
                  </p>
                  <ul className="font-normal text-base text-[#5F6870] sm:text-lg md:text-lg list-disc space-y-5 ml-5">
                    <li>
                      Employees working 3 days/week from the office are
                      eligible.
                    </li>
                    <li>
                      GCC employees will receive access to in-campus gym and
                      wellness facilities once operations begin.
                    </li>
                  </ul>
                </>

                <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-8 sm:gap-10 lg:gap-12 mt-14">
                  {currentTabData?.otherEmpBenefits?.map((i, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        if (i?.title === "Policies") {
                          handlePoliciesDownload();
                        }
                      }}
                      className={`flex max-w-[27rem] flex-col items-center text-center
                          bg-[#F0F6FF] rounded-[1rem] p-6
                          ${
                            i?.title === "Policies"
                              ? "cursor-pointer hover:shadow-lg transition"
                              : ""
                          }
                        `}
                    >
                      <div className="mb-4">
                        <img
                          src={i?.image}
                          alt={i?.title}
                          className="bg-white p-1"
                        />
                      </div>

                      <h3 className="text-xl font-bold text-[#0F172A] mb-2">
                        {i?.title}
                      </h3>

                      <p className="text-[#0F172A] text-lg font-400 leading-relaxed">
                        {i?.p}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
              <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
                <div className="flex flex-col lg:flex-row items-center gap-10">
                  <div className="flex-1 w-full space-y-6">
                    <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                      <span className="w-[21px] h-[6px] bg-activeColor"></span>
                      <span className="w-[36px] h-[6px] bg-activeColor"></span>
                    </span>
                    <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                      Gratuity
                    </h2>
                    <p className="font-400 text-lg text-[#404040]">
                      Gratuity is offered as a financial appreciation for
                      long-term service. Employees who complete five years with
                      TechProjects become eligible, and the amount is paid upon
                      leaving the organization.
                    </p>
                  </div>

                  <div className="flex-1 flex items-center justify-center">
                    <img
                      src={image389}
                      alt="Idea Concept"
                      className="max-w-md w-full object-contain"
                    />
                  </div>
                </div>
              </div>
            </section>

            <section className="py-14 px-4 md:px-20 font-roboto bg-white">
              <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
                <div className="flex flex-col lg:flex-row items-center gap-10">
                  <div className="flex-1 flex items-center justify-center">
                    <img
                      src={image387}
                      alt="Idea Concept"
                      className="max-w-md w-full object-contain"
                    />
                  </div>
                  <div className="flex-1 w-full space-y-6">
                    <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                      <span className="w-[21px] h-[6px] bg-activeColor"></span>
                      <span className="w-[36px] h-[6px] bg-activeColor"></span>
                    </span>
                    <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                      Provident Fund & Statutory Welfare
                    </h2>
                    <p className="font-500 text-[#434253] text-3xl">
                      Under the EPF scheme, TechProjects supports your long-term
                      financial security.
                    </p>
                    <ul className="font-normal text-[#5F6870] sm:text-lg md:text-xl list-disc mt-6 md:mt-16 space-y-5 ml-5">
                      <li>The company contributes up to ₹1,800 per month.</li>
                      <li>Employees may add voluntary contributions.</li>
                      <li>
                        You also have the option to contribute up to 12% of your
                        basic salary.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
              <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
                <div className="flex flex-col lg:flex-row items-center gap-10">
                  <div className="flex-1 w-full space-y-6">
                    <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                      <span className="w-[21px] h-[6px] bg-activeColor"></span>
                      <span className="w-[36px] h-[6px] bg-activeColor"></span>
                    </span>
                    <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                      Wellness Program
                    </h2>
                    <p className="font-500 text-[#434253] text-3xl">
                      Our wellness initiatives focus on promoting employee
                      health and balance.
                    </p>
                    <ul className="font-normal text-[#5F6870] sm:text-lg list-disc md:text-xl mt-6 md:mt-16 space-y-5 ml-5">
                      <li>
                        Yoga & Mindfulness Sessions that support mental clarity,
                        relaxation, and stress management.
                      </li>
                      <li>
                        Indoor & Outdoor Sports Activities that promote physical
                        fitness, teamwork, and an active lifestyle.
                      </li>
                    </ul>
                  </div>
                  <div className="flex-1 flex items-center justify-center">
                    <img
                      src={image388}
                      alt="Idea Concept"
                      className="max-w-md w-full object-contain"
                    />
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tab === "usaEmployees" && (
          <>
            <section className="w-full py-12 bg-white font-roboto">
              <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-6 md:px-0">
                <div className="flex gap-6">
                  <img src={freepik} alt="freepik" className="object-contain" />
                  <div className="grid  items-center mb-2">
                    <h2 className="text-4xl font-bold text-[#434253]">
                      E-Verify Program
                    </h2>
                    <p className="text-[#404040] font-400 text-lg">
                      TechProjects participates in the U.S. Department of
                      Homeland Security’s E-Verify Program to confirm employment
                      eligibility.
                    </p>
                  </div>
                </div>

                <div className="mt-12 relative min-h-[150px] bg-[linear-gradient(180deg,rgba(6,43,150,0)_41.35%,rgba(147,175,255,0.3)_100%)] rounded-[1rem] border border-[#e4e4e4]">
                  <img
                    src={Vector2122}
                    alt="vector"
                    className="absolute inset-0 h-full w-full rounded-[1rem]"
                  />

                  <div className="absolute flex items-center justify-center h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 left-0 right-0">
                    <div className="font-roboto space-y-6">
                      <p className="text-xl font-400 text-[#77828f]">
                        Company ID:{" "}
                        <span className="font-bold text-2xl text-[#e85765]">
                          905575
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="w-full bg-white py-10 px-5 md:px-12 lg:px-20 font-roboto">
              <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-end">
                <div>
                  <h2 className="text-4xl font-bold text-[#434253] mb-4">
                    Employee Resources
                  </h2>
                  <p className="text-[#404040] font-400 text-lg">
                    Access your benefits, handbooks, and policy documents easily
                    through the links below.
                  </p>

                  <div className="space-y-5 mt-6">
                    {EmpResourceData?.map((item, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-center bg-[#F2F8FF] transition rounded-lg py-2 px-6 shadow-sm"
                      >
                        <div className="flex items-center gap-3">
                          <img src={item?.icon} alt={item?.title} />
                          <span className="font-medium text-[#5F6870] text-xl">
                            {item.title}
                          </span>
                        </div>
                        <button
                          onClick={() => handleAction(item)}
                          download
                          className="p-2 bg-white border border-[#D0D5DD] rounded-lg shadow-[#1018280D]"
                        >
                          <img src={downloadIcon} alt="download" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex justify-center">
                  <img
                    src={image366}
                    alt="Employee Resources Illustration"
                    className="w-full max-w-md md:max-w-lg"
                  />
                </div>
              </div>
            </section>

            <section className="bg-[#F7F7F7] py-16 px-4 md:px-20 text-center font-roboto">
              <div className="flex flex-col items-start mb-6 sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto">
                <span className="flex items-start font-bold text-lg tracking-wider space-x-2 mb-4">
                  <span className="w-[21px] h-[6px] bg-activeColor"></span>
                  <span className="w-[36px] h-[6px] bg-activeColor"></span>
                </span>
                <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] mb-4 text-start">
                  Why Employees Love Working at TechProjects
                </h2>
                <p className="text-[#404040] font-400 text-lg text-start">
                  At TechProjects, we believe great work comes from a great
                  environment. Our people enjoy a balanced, supportive, and
                  growth-driven culture that helps them thrive — both
                  professionally and personally.
                </p>
              </div>

              <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 mt-16">
                {workingTechproject?.map((i, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center sm:items-center lg:items-center text-center sm:text-center lg:text-center bg-[#F0F6FF] rounded-[1rem] p-6"
                  >
                    <div className="mb-4 p-2 bg-white">
                      <img src={i?.image} alt={i?.title} />
                    </div>
                    <h3 className="text-xl font-bold text-[#0F172A] mb-3">
                      {i?.title}
                    </h3>
                    <p className="text-[#0F172A] text-lg font-400 leading-relaxed px-5">
                      {i?.p}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section className="bg-white py-16 px-4 md:px-20 text-center font-roboto">
              <div className="flex flex-col items-start mb-6 sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto">
                <span className="flex items-start font-bold text-lg tracking-wider space-x-2 mb-4">
                  <span className="w-[21px] h-[6px] bg-activeColor"></span>
                  <span className="w-[36px] h-[6px] bg-activeColor"></span>
                </span>
                <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] mb-4 text-start">
                  Bring Great People, Earn Great Rewards
                </h2>
                <p className="text-[#404040] font-400 text-lg text-start">
                  Help us find top talent and earn $1,000 for every successful
                  referral!
                </p>
              </div>
              <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid md:grid-cols-2 gap-10 items-start">
                <div className="">
                  <div className="space-y-5 mt-6">
                    {rewardsData?.map((item, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-center bg-[#F2F8FF] transition rounded-lg py-2 px-6 shadow-sm"
                      >
                        <div className="flex items-center gap-3">
                          <img src={item?.icon} alt={item?.title} />
                          <span className="font-medium text-[#5F6870] text-xl">
                            {item.title}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <button
                    type="submit"
                    className="mt-10 border-[#BE123C] border-2 bg-activeColor text-white text-xl px-6 py-3 rounded-md font-500 hover:bg-red-600 transition-all flex items-center gap-6"
                  >
                    Submit Referral Now
                  </button>
                </div>

                <div className="flex justify-center">
                  <img
                    src={image369}
                    alt="Employee Resources Illustration"
                    className="w-full max-w-md md:max-w-lg"
                  />
                </div>
              </div>
            </section>

            <section className="bg-[#F7F7F7] py-16 px-4 md:px-20 text-center font-roboto">
              <div className="flex flex-col items-start mb-6 sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto">
                <span className="flex items-start font-bold text-lg tracking-wider space-x-2 mb-4">
                  <span className="w-[21px] h-[6px] bg-activeColor"></span>
                  <span className="w-[36px] h-[6px] bg-activeColor"></span>
                </span>
                <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] mb-4 text-start">
                  Open Referral Roles
                </h2>
              </div>
              <div className="grid space-y-5 sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto">
                {roles?.map((i, id) => (
                  <div
                    key={id}
                    className="bg-[#F0F6FF] rounded-2xl flex flex-col md:flex-row justify-between items-start md:items-center p-5 md:p-6 shadow-sm border border-[#E2E8F0]"
                  >
                    <div className="grid items-start gap-3">
                      <div className="flex gap-3">
                        <img src={PIcon} className="p-1" />
                        <h2 className="text-lg md:text-xl font-bold text-[#0F172A]">
                          {i?.role}
                        </h2>
                      </div>

                      <div className="text-start grid space-y-1">
                        <p className="text-lg text-[#5F6870]">
                          {i?.work}{" "}
                          <span className="font-semibold text-[#0F172A]">
                            {i?.workPlace}
                          </span>
                        </p>
                        <p className="text-lg text-[#5F6870]">
                          {i?.d2}{" "}
                          <span className="font-semibold text-[#0F172A]">
                            {i?.workExp}
                          </span>
                        </p>
                        {/* <p className="text-lg text-[#5F6870]">
                        {i?.ref}{" "}
                        <span className="font-semibold text-[#0F172A]">
                          {i?.date}
                        </span>
                      </p> */}
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="border-[#BE123C] mt-5 md:mt-0 border-2 bg-activeColor text-white text-sm p-2 rounded-md font-500 hover:bg-red-600 transition-all flex items-center gap-6"
                    >
                      Refer Candidate
                    </button>
                  </div>
                ))}
              </div>
            </section>

            <div className="relative min-h-[500px] bg-[#F7F7F7]">
              <img
                src={Banner}
                alt="About Banner"
                className="absolute inset-0 h-full w-full rotate-[180deg]"
              />

              <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 left-0 right-0">
                <div className="max-w-3xl font-roboto space-y-6">
                  <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                    <span className="w-[21px] h-[6px] bg-activeColor"></span>
                    <span className="w-[36px] h-[6px] bg-activeColor"></span>
                  </span>
                  <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] mb-5">
                    Equal Opportunity, Every Step of the Way
                  </h2>
                  <p className="text-[#404040] text-md md:text-lg font-400 leading-relaxed">
                    We’re proud to foster an inclusive workplace where everyone
                    is treated fairly — regardless of race, gender, age, or
                    background.
                  </p>
                </div>

                <div className="max-w-xl flex justify-end">
                  <img
                    src={image368}
                    alt="Equal Opportunity"
                    className="w-full max-w-xl object-cover"
                  />
                </div>
              </div>
            </div>
          </>
        )}
        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-4xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Have Questions? We’re Here to Help.
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1] max-w-3xl  mx-auto">
              Our HR team is available to assist you with benefits, policies, or
              referrals.
            </p>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Contact HR Now
              </button>
            </div>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default Employee;
